// extracted by mini-css-extract-plugin
module.exports = {"section":"styles__section___bwmIi","horizontalTable":"styles__horizontalTable___31fwd"};